import {useState, useEffect} from "react"
import {TagKind} from "@irati/types"
import tagService from "@irati/tag/services/tag"

export interface SimpleTag {
  name: string
  uuid: string
}

export function useTags() {
  const [tags, setTags] = useState<SimpleTag[]>()
  useEffect(() => {
    tagService.list({kind: TagKind.BudgetTag}).then((tt) => {
      setTags(tt.map(({name, uuid}) => ({name, uuid})).filter((t): t is SimpleTag => Boolean(t.name)))
    })
  }, [])
  return tags
}
